module.exports = __webpack_public_path__ + "img/fondo_login.7b85ecf8.png";